<template>
  <div class="category-menu" v-arrowscroll>
    <div class="category-menu__container" v-if="categoriesLoading">
      <div class="skeleton" style="height: 21px; width: 180px;" />
      <div class="skeleton" style="height: 21px; width: 90px; margin-left: 20px" />
      <div class="skeleton" style="height: 21px; width: 120px; margin-left: 20px" />
    </div>
    <div class="category-menu__container" v-else>
      <a
        class="category-menu__item"
        :class="{ 'category-menu__item--active': categoriesCurrent === null }"
        @click="changeCategoriesCurrent(null)
      ">
        <span>Toate Categoriile</span>
      </a>

      <a
        class="category-menu__item"
        :class="{ 'category-menu__item--active': 
          (
            categoriesCurrent !== null
            && category.id === categoriesCurrent.id
          )
        }"
        @click="changeCategoriesCurrent(category)"
        v-for="(category,i) of categories" :key="i"
      >
        <span>{{ category.name }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  mounted() {
    if (this.categories.length === 0) {
      this.fetchCategories();
    }
  },
  computed: {
    ...mapGetters({
      categories        : 'articles/categories',
      categoriesCurrent : 'articles/categoriesCurrent',
      categoriesLoading : 'articles/categoriesLoading',
      isMobile: 'layout/isMobile'
    })
  },
  methods: {
    ...mapActions({
      changeCategoriesCurrent : 'articles/changeCategoriesCurrent',
      fetchCategories         : 'articles/fetchCategories',
    }),
  }
}
</script>

<style lang="scss" scoped>
.category-menu {
  width: 100%;

  &__container {
    display: flex;
    overflow: auto;
    padding-bottom: 18px;
    padding-top: 18px;
    margin: 0px 10px;
    cursor: grab;
  }

  &__item {
    color: $color-gray;
    cursor: pointer;
    font-size: 19px;
    font-weight: 400;
    letter-spacing: -0.2px;
    margin-right: 30px;
    position: relative;
    text-decoration: none;
    transition: color 300ms;
    white-space: nowrap;

    @include media-breakpoint-up(md) {
      font-size: 21.333px;
      margin-right: 50px;
    }

    & > span {
      display: block;
      font-size: inherit;
      font-weight: inherit;
      letter-spacing: inherit;
      position: relative;
      transition: transform 300ms;
    }

    &:last-child {
      margin-right: 0;
    }

    &--active {
      color: $color-primary;
      font-weight: 700;
    }

    &:not(&--active):hover {
      color: $color-primary;

      & > span {
        transform: translateY(-2px);
      }
    }

    &::after {
      background: $gradient-nexyo;
      bottom: -18px;
      content: '';
      left: 50%;
      pointer-events: none;
      position: absolute;
      height: 2px;
      transform: translateX(-50%);
      transition: bottom 300ms, width 300ms;
      user-select: none;
      width: 0;
    }

    &--active::after {
      background: $gradient-nexyo;
    }

    &--active::after,
    &:hover::after {
      width: 100%;
    }
  }
}
</style>
